import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./components/App/App";

const locationPickerContainer = document.querySelector(".locationPicker");
const bridgemodeContainer = document.getElementById("bridgemode");

window.altibox.apps.locationPicker.init(locationPickerContainer!);
window.altibox.apps.locationPicker.subscribe((location: { siteId: number }) => {
  ReactDOM.unmountComponentAtNode(bridgemodeContainer!);
  ReactDOM.render(<App siteId={location.siteId} />, bridgemodeContainer);
});

declare global {
  interface Window {
    altibox: {
      apps: {
        locationPicker: {
          init: (container: Element) => void;
          subscribe: (fn: Function) => void;
        };
      };
    };
  }
}
